import React from 'react';
import NavBar from '../components/NavBar';
import ContactContent from '../components/ContactContent';
import Contact from '../components/Contact';

const ContactUs = () => {
  return (
    <div>
        <NavBar />
        <ContactContent />
        <Contact />
    </div>
  )
}

export default ContactUs;